import React, {FC, useMemo} from 'react';
import messages from '../messages';
import {STATUSES} from './constant';
import {OverpaymentFilters} from './types';
import AsyncItemPicker from 'components/async-item-picker';
import DateRangeInput from 'components/date-range-input';
import ItemPicker from 'components/item-picker';
import {FilterMap} from 'features/table/slice/types';
import {useTranslation} from 'react-i18next';
import {Col, Collapse, FormGroup, Row} from 'reactstrap';
import {Option} from 'types/option';
import SearchSection from 'features/table/compenents/search-section';

interface FilterProps {
  filters: FilterMap<OverpaymentFilters>;
  onChangeFilters: (key: OverpaymentFilters, value: any) => void;
  onClearFilters?: () => void;
}

const Filters: FC<FilterProps> = props => {
  const {t} = useTranslation();
  const {filters, onChangeFilters, onClearFilters} = props;

  const statuses = useMemo(() => {
    return STATUSES.map(x => {
      return {
        ...x,
        name: t(...x.name()),
      };
    });
  }, []);

  return (
    <SearchSection
      onChangeFilters={onChangeFilters}
      onClearFilters={onClearFilters}
      filters={filters}
    >
      <Row className="mb-3">
        <Col lg="6" md="6">
          <FormGroup>
            <DateRangeInput
              label={t('invoicesPage.payementDate')}
              value={filters['filter[payment_date]'] as string}
              onChange={newDate => {
                onChangeFilters('filter[payment_date]', newDate);
              }}
            />
          </FormGroup>
        </Col>
        <Col lg="6" md="6">
          <FormGroup>
            <AsyncItemPicker
              endPoint="data/commercial-types?order&invoice"
              className="mb-1"
              label={t('invoicesPage.type')}
              value={filters['filter[commercial_type_id]']}
              onChange={o => onChangeFilters('filter[commercial_type_id]', o)}
            />
          </FormGroup>
        </Col>
      </Row>
    </SearchSection>
  );
};

export default Filters;
